module.exports = __webpack_public_path__ + "img/medal.16588f22.svg";